import api from './api'

export const authService = {
  async login(credentials) {
    return await api.post('/auth/login', credentials)
  },

  async register(userData) {
    return await api.post('/auth/register', userData)
  },

  async logout() {
    return await api.post('/auth/logout')
  },

  async refresh() {
    return await api.post('/auth/refresh')
  },

  async me() {
    return await api.get('/auth/me')
  },

  async verify2FA(tempToken, code) {
    return await api.post('/auth/verify-2fa', {
      temp_token: tempToken,
      code: code
    })
  },

  async requestPasswordReset(email) {
    return await api.post('/auth/password/reset', { email })
  },

  async resetPassword(token, email, password, passwordConfirmation) {
    return await api.post('/auth/password/update', {
      token,
      email,
      password,
      password_confirmation: passwordConfirmation
    })
  }
}